import { render, staticRenderFns } from "./KeypointPanel.vue?vue&type=template&id=ba75e03a&scoped=true&"
import script from "./KeypointPanel.vue?vue&type=script&lang=js&"
export * from "./KeypointPanel.vue?vue&type=script&lang=js&"
import style0 from "./KeypointPanel.vue?vue&type=style&index=0&id=ba75e03a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba75e03a",
  null
  
)

component.options.__file = "KeypointPanel.vue"
export default component.exports